import Layout2 from "@/components/Layout/Layout2";
import LeftBar2 from "@/components/Layout/LeftBar2";
import React from "react";
import { useState } from "react";
import { backofficeLinks } from "@/components/lib/SidebarLinks";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Table,
  TableHead,
  TableHeader,
  TableRow,
  TableBody,
  TableCell,
} from "@/components/ui/table";
import { AddExtraSalaryDialog } from "@/components/dialog/staff-manage/payroll-dialog";

function PayrollDetails() {
  const [openExtraSalaryDialog, setOpenExtraSalaryDialog] = useState(false);

  const onDialog = () => {
    setOpenExtraSalaryDialog(true);
  };

  const offDialog = () => {
    setOpenExtraSalaryDialog(false);
  };

  return (
    <Layout2
      LeftBar={<LeftBar2 sidebarLinks={backofficeLinks} />}
      pageName={{ icon: true, title: "Payroll" }}
      paths={[
        { name: "Back Office", path: "/backoffice/overview" },
        {
          name: "Staff Management",
          path: "/backoffice/staff-management/staff/all",
        },
        {
          name: "Payroll",
          path: "/backoffice/staff-management/payroll",
        },
        { name: "Gtki253", path: "/backoffice/staff-management/payroll" },
      ]}
    >
      <div className="container flex flex-col gap-6 mt-5 pb-8 text-cwhite">
        <div className="flex justify-between items-center w-full">
          <h1 className="text-xl font-semibold text-cwhite">January 2025</h1>
          <Button onClick={onDialog} className="bg-cyellow text-cblack font-medium hover:bg-cyellow/90 transition-colors">
            <Plus size={"20"} />
            Add extra Salary
          </Button>
          <AddExtraSalaryDialog
            offDialog={offDialog}
            openExtraSalary={openExtraSalaryDialog}
          />
        </div>

        <div className="bg-cblack3 px-6 py-6 rounded-lg border border-white/10 grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="flex flex-col gap-3">
            <h2 className="text-base font-semibold text-cwhite">Bill From</h2>
            <div className="flex flex-col space-y-1 text-cwhite3 text-sm">
              <span>Amannah LTD</span>
              <span>+235626562</span>
              <span>demo@gmail.com</span>
              <span>12/45 House, London</span>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            <h2 className="text-base font-semibold text-cwhite">Billing Address</h2>
            <div className="flex flex-col space-y-1 text-cwhite3 text-sm">
              <span>Name: Jems</span>
              <span>Designation: Manager</span>
              <span>Email: demo@gmail.com</span>
              <span>Phone: +96857425</span>
              <span>Address: 12/45 House, USA</span>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            <h2 className="text-base font-semibold text-cwhite">Payment Details</h2>
            <div className="flex flex-col space-y-1 text-cwhite3 text-sm">
              <span>Method: Bank Account</span>
              <span>Account Holder Name: Jems</span>
              <span>Bank Name: Dhaka Bank</span>
              <span>Branch: Dhaka</span>
              <span>Account AC No: 3658945789658</span>
            </div>
          </div>
        </div>

        <div className="overflow-x-auto w-full">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Date</TableHead>
                <TableHead>Basic Salary</TableHead>
                {/* <TableHead>Profit Share</TableHead> */}
                <TableHead>Bonus</TableHead>
                <TableHead>TAX</TableHead>
                <TableHead>Medical F</TableHead>
                <TableHead>Net Salary</TableHead>
                <TableHead>Status</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              <TableRow>
                <TableCell>1</TableCell>
                <TableCell>$500</TableCell>
                {/* <TableCell>$50</TableCell> */}
                <TableCell>$50</TableCell>
                <TableCell>$50</TableCell>
                <TableCell>$50</TableCell>
                <TableCell>$50</TableCell>
                <TableCell className="text-cgreen flex items-center gap-1 cursor-pointer">
                  <span className="text-[7px]">🟢</span>Paid
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>

        <div className="mt-4">
          <h2 className="text-lg font-semibold text-cwhite mb-3">Extra Payment</h2>
          <div className="overflow-x-auto w-full">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Serial</TableHead>
                  <TableHead>Earning</TableHead>
                  <TableHead>Type</TableHead>
                  <TableHead className="text-right">Amount</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                <TableRow>
                  <TableCell className="bg-transparent h-14">1</TableCell>
                  <TableCell className="bg-transparent">
                    Dearness Allowance
                  </TableCell>
                  <TableCell className="bg-transparent">-</TableCell>
                  <TableCell className="bg-transparent text-right">
                    $5000
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="bg-transparent h-14">2</TableCell>
                  <TableCell className="bg-transparent">
                    Transport Allowance
                  </TableCell>
                  <TableCell className="bg-transparent">As per need</TableCell>
                  <TableCell className="bg-transparent text-right">
                    $5000
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="bg-transparent h-14">3</TableCell>
                  <TableCell className="bg-transparent">Mobile Bill</TableCell>
                  <TableCell className="bg-transparent">As per need</TableCell>
                  <TableCell className="bg-transparent text-right">
                    $5000
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </div>
        </div>

        <div className="bg-cblack3 px-6 py-5 rounded-lg border border-white/10 flex justify-end">
          <div className="flex gap-20 items-center">
            <div className="flex flex-col space-y-1 text-cwhite2 text-sm font-medium">
              <span>Subtotal</span>
              <span>Net Salary</span>
              <span>Total Payable</span>
            </div>
            <div className="flex flex-col space-y-1 text-cwhite3 text-sm">
              <span>$5000</span>
              <span>$5000</span>
              <span>$10000</span>
            </div>
          </div>
        </div>

        <div className="flex justify-end gap-4 items-center mt-2 flex-wrap">
          <Button className="bg-cviolet text-white hover:bg-cviolet/90">Send Email</Button>
          <Button className="bg-cpurple text-white hover:bg-cpurple/90">Download</Button>
          <Button className="bg-cyellow text-cblack font-medium hover:bg-cyellow/90">Print</Button>
          <Button className="bg-cgreen text-white hover:bg-cgreen/90">Make As Paid</Button>
        </div>
      </div>
    </Layout2>
  );
}

export default PayrollDetails;
